<template>
  <div v-if="!loading">
    <v-alert
      v-if="form.swot_socialny_podnik_dostupny || form.swot_socialny_podnik_akceptovany_nazov || form.swot_zabezpecena_nadvazna_starostlivost || form.swot_poziadal_o_spolupracu_obec"
      dense
      outlined
      color="info"
    >
      <v-row v-if="form.swot_socialny_podnik_dostupny || form.swot_socialny_podnik_akceptovany_nazov">
        <v-col cols="auto">
          Klient prejavil záujem o prácu v sociálnom podniku.
          <span v-if="form.swot_socialny_podnik_akceptovany_nazov">
            Bol prejavený záujem zo strany sociálneho podniku <strong>{{ form.swot_socialny_podnik_akceptovany_nazov }}</strong>, klient ponuku akceptoval.</span>
        </v-col>
      </v-row>
      <v-row v-if="form.swot_zabezpecena_nadvazna_starostlivost">
        <v-col>
          Klient prejavil záujem o riešenie problému v organizácii <strong>{{ form.swot_zabezpecena_nadvazna_starostlivost_text }}</strong>.
        </v-col>
      </v-row>

      <v-row v-if="form.swot_poziadal_o_spolupracu_obec">
        <v-col>
          Klient prejavil požiadal o súčinnosť obec/mesto <strong>{{ form.swot_poziadal_o_spolupracu_obec_text }}</strong>.
        </v-col>
      </v-row>
    </v-alert>

    <v-alert
      dense
      text
      color="info"
      icon="mdi-information-outline"
      class="ma-4"
    >
      <div class="text-caption">
        <strong>Aktuálny stav:</strong> Zaznamenávajte priebeh a pokrok klienta pri resocializácii<br>
        <strong>Prepojenie so SWOT:</strong> Horné upozornenie zobrazuje informácie z analýzy SWOT (sociálne podniky, náväzná starostlivosť, spoluporáca s obcou)
      </div>
    </v-alert>

    <form>
      <!-- <h1 class="title font-weight-regular">
        Informácie pracovníkov UVTOS:
      </h1>

      <v-row
        v-for="(input, index) in form.informacie_uvtos"
        :key="input.id"
        dense
      >
        <v-col
          md="1"
          sm="12"
          cols="12"
        >
          <v-text-field
            v-model="input.datum"
            label="Dátum"
            name="Dátum"
            class="pr-2"
          />
        </v-col>

        <v-col
          md="11"
          sm="12"
          cols="12"
        >
          <v-textarea
            v-model="input.text"
            :disabled="form.closed"
            label="Popis"
            name="Popis"
            rows="1"
            auto-grow
            append-icon="mdi-delete"
            @click:append="deleteRowInformacieUVTOS(index)"
          />
        </v-col>
        <v-col
          md="12"
          sm="12"
          cols="12"
        >
          <hidden-attachments
            :size="input.files.length"
            v-if="input.id"
          >
            <v-card>
              <v-card-text>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Meno
                        </th>
                        <th class="text-left">
                          Čas pridania
                        </th>
                        <th class="text-left">
                          Akcie
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in input.files"
                        :key="item.id"
                      >
                        <td>{{ item.name }}</td>
                        <td>{{ item.created_at }}</td>
                        <td>
                          <v-btn
                            small
                            @click="downloadAttachment(item)"
                          >Stiahnuť súbor</v-btn>
                          <v-btn
                            small
                            color="error"
                            class="ml-10"
                            @click="deleteAttachmentUVTOS(item)"
                          >Zmazať súbor</v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="10">

                    <v-file-input
                      show-size
                      v-model="input.file"
                      label="Súbor"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      color="info"
                      @click="uploadFileUVTOS(input.file, input.id)"
                    >Upload</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </hidden-attachments>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-btn
            text
            icon
            color="secondary"
            @click="addRowInformacieUVTOS"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row> -->

      <h1 class="title font-weight-regular">
        Informácie pracovníkov UPSVR:
      </h1>

      <v-row
        v-for="(input, index) in form.informacie_upsvar"
        :key="index"
        dense
      >
        <v-col
          md="2"
          sm="12"
          cols="12"
        >
          <v-text-field
            v-model="input.datum"
            label="Dátum"
            name="Dátum"
            class="pr-2"
          />
        </v-col>

        <v-col
          md="10"
          sm="12"
          cols="12"
        >
          <v-textarea
            v-model="input.text"
            :disabled="form.closed"
            label="Popis"
            name="Popis"
            rows="1"
            auto-grow
            append-icon="mdi-delete"
            @click:append="deleteRowInformacieUPSVAR(index)"
          />
        </v-col>

        <v-col
          v-if="input.id"
          cols="12"
        >
          <hidden-attachments :size="input.files.length">
            <v-card>
              <v-card-text>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Meno
                        </th>
                        <th class="text-left">
                          Čas pridania
                        </th>
                        <th class="text-left">
                          Akcie
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in input.files"
                        :key="item.id"
                      >
                        <td>{{ item.name }}</td>
                        <td>{{ item.created_at }}</td>
                        <td>
                          <v-btn
                            small
                            @click="downloadAttachment(item)"
                          >
                            Stiahnuť súbor
                          </v-btn>
                          <v-btn
                            small
                            color="error"
                            class="ml-10"
                            @click="deleteAttachmentUPSVAR(item)"
                          >
                            Zmazať súbor
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="10">
                    <v-file-input
                      v-model="input.file"
                      show-size
                      label="Súbor"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      color="info"
                      @click="uploadFileUPSVAR(input.file, input.id)"
                    >
                      Upload
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </hidden-attachments>
        </v-col>
      </v-row>

      <v-btn
        text
        icon
        color="secondary"
        @click="addRowInformacieUPSVAR"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <!-- Form Actions -->
      <v-divider class="my-6" />
      <FormActions
        v-if="!form.closed"
        ref="formActions"
        :fixed="false"
        :is-dirty="isDirty"
        :loading="loading"
        save-text="Uložiť"
        @save="updateItem"
      />
    </form>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="AktualnyStav" />
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api';
import { useRoute } from '@/composables/useRouter.js';
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";
import HiddenAttachments from "../components/HiddenAttachments.vue";
import FormActions from "@/components/FormActions.vue";
import { useIapszForm } from "@/composables/useIapszForm.js";
import { useFormDirty } from "@/composables/useFormDirty.js";

const apiService = new APIService();

export default {
  components: {
    "form-skeleton-component": FormSkeleton,
    "hidden-attachments": HiddenAttachments,
    FormActions,
  },

  setup() {
    const route = useRoute();
    
    const { loading, setLoading, handleSaveSuccess, handleSaveError } = useIapszForm();
    const formActions = ref(null);
    
    const uploading = ref(false);
    const form = ref({
      id: null,
      closed: false,
      informacie_uvtos: [{ datum: "", text: "" }],
      informacie_upsvar: [{ datum: "", text: "" }],
    });
    
    const initialForm = ref({});
    const { isDirty, markAsPristine, enableBrowserWarning } = useFormDirty(initialForm, form, { deep: true });
    enableBrowserWarning();

    const downloadAttachment = (item) => {
      apiService.downloadItem(item.file, item.name);
    };

    const deleteAttachmentUVTOS = (item) => {
      apiService.deleteInformacieUVTOSFile(item).then(() => getItem());
    };

    const uploadFileUVTOS = (file, id) => {
      uploading.value = true;
      const formData = new FormData();
      formData.set("informacie_uvtos", id);
      if (file instanceof File) formData.append("file", file);
      formData.append("name", file.name);

      apiService.createInformacieUVTOSFile(formData).then(
        () => {
          handleSaveSuccess();
          getItem();
        },
        () => {
          uploading.value = false;
          handleSaveError();
        }
      );
    };

    const deleteAttachmentUPSVAR = (item) => {
      apiService.deleteInformacieUPSVARFile(item).then(() => getItem());
    };

    const uploadFileUPSVAR = (file, id) => {
      const formData = new FormData();
      formData.set("informacie_upsvar", id);
      if (file instanceof File) formData.append("file", file);
      formData.append("name", file.name);

      apiService.createInformacieUPSVARFile(formData).then(
        () => {
          handleSaveSuccess();
          getItem();
        },
        () => {
          handleSaveError();
        }
      );
    };

    const getItem = () => {
      setLoading(true);
      apiService.getIapszAktualnyStav(route.params.id).then((response) => {
        form.value = response;
        initialForm.value = JSON.parse(JSON.stringify(response));
        markAsPristine();
        setLoading(false);
      });
    };

    const updateItem = () => {
      apiService.updateIapszAktualnyStav(form.value, route.params.id).then(
        (response) => {
          handleSaveSuccess();
          if (formActions.value) {
            formActions.value.showSuccess();
          }
          form.value = response;
          markAsPristine();
        },
        () => {
          handleSaveError();
          if (formActions.value) {
            formActions.value.showError();
          }
        }
      );
    };

    const addRowInformacieUVTOS = () => {
      form.value.informacie_uvtos.push({
        aktualny_stav: form.value.id,
        datum: null,
        text: null,
        files: [],
      });
    };

    const deleteRowInformacieUVTOS = (index) => {
      form.value.informacie_uvtos.splice(index, 1);
    };

    const addRowInformacieUPSVAR = () => {
      form.value.informacie_upsvar.push({
        aktualny_stav: form.value.id,
        datum: null,
        text: null,
        files: [],
      });
    };

    const deleteRowInformacieUPSVAR = (index) => {
      form.value.informacie_upsvar.splice(index, 1);
    };

    onMounted(() => {
      getItem();
    });

    return {
      uploading,
      loading,
      form,
      isDirty,
      formActions,
      downloadAttachment,
      deleteAttachmentUVTOS,
      uploadFileUVTOS,
      deleteAttachmentUPSVAR,
      uploadFileUPSVAR,
      updateItem,
      addRowInformacieUVTOS,
      deleteRowInformacieUVTOS,
      addRowInformacieUPSVAR,
      deleteRowInformacieUPSVAR,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      if (window.confirm('Máte neuložené zmeny. Naozaj chcete odísť?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>